import {Puzzle} from '../../components/puzzle.js';
import {DefaultGameRules} from '../../components/rules/default-game-rules.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {PowerupPerk} from '../PowerupPerk.js';

/**
 * Chain booster Perk
 * The original in Unity was called `ChainBoosterPowerup`
 */
export class ChainBoosterPerk extends PowerupPerk {
    perkStat: TransactionalNames = TransactionalNames.ComboChainUpgrade;
    tagToAdjust = 'ComboChain';

    private _chainBonus1 = 1.5;
    private _chainBonus2 = 2;
    private _chainBonus3 = 2.5;
    private _chainBonus4 = 3;
    private _chainBonus5 = 5;

    execute() {
        let upgradeLevel = Statistics.instance.getTransactional(this.perkStat);
        let chainBonus = 1;
        switch (upgradeLevel) {
            case 1:
                chainBonus = this._chainBonus1;
                break;
            case 2:
                chainBonus = this._chainBonus2;
                break;
            case 3:
                chainBonus = this._chainBonus3;
                break;
            case 4:
                chainBonus = this._chainBonus4;
                break;
            case 5:
                chainBonus = this._chainBonus5;
                break;
        }

        if (Puzzle.instance.rules instanceof DefaultGameRules) {
            const myRules = Puzzle.instance.rules as DefaultGameRules;
            myRules.chainBonus = chainBonus;
        }
    }
}
